// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-templates-posts-js": require("gatsby-module-loader?name=component---src-templates-posts-js!/app/src/templates/posts.js"),
  "component---src-templates-post-js": require("gatsby-module-loader?name=component---src-templates-post-js!/app/src/templates/post.js"),
  "component---src-templates-work-js": require("gatsby-module-loader?name=component---src-templates-work-js!/app/src/templates/work.js"),
  "component---src-pages-404-js": require("gatsby-module-loader?name=component---src-pages-404-js!/app/src/pages/404.js"),
  "component---src-pages-index-js": require("gatsby-module-loader?name=component---src-pages-index-js!/app/src/pages/index.js"),
  "component---src-pages-index-old-js": require("gatsby-module-loader?name=component---src-pages-index-old-js!/app/src/pages/index.old.js"),
  "component---src-pages-page-2-js": require("gatsby-module-loader?name=component---src-pages-page-2-js!/app/src/pages/page-2.js"),
  "component---src-pages-test-js": require("gatsby-module-loader?name=component---src-pages-test-js!/app/src/pages/test.js")
}

exports.json = {
  "layout-index.json": require("gatsby-module-loader?name=path---!/app/.cache/json/layout-index.json"),
  "blog.json": require("gatsby-module-loader?name=path---blog!/app/.cache/json/blog.json"),
  "blog-my-second-post.json": require("gatsby-module-loader?name=path---blog-my-second-post!/app/.cache/json/blog-my-second-post.json"),
  "blog-my-first-post.json": require("gatsby-module-loader?name=path---blog-my-first-post!/app/.cache/json/blog-my-first-post.json"),
  "work-ballantines.json": require("gatsby-module-loader?name=path---work-ballantines!/app/.cache/json/work-ballantines.json"),
  "404.json": require("gatsby-module-loader?name=path---404!/app/.cache/json/404.json"),
  "index.json": require("gatsby-module-loader?name=path---index!/app/.cache/json/index.json"),
  "index-old.json": require("gatsby-module-loader?name=path---index-old!/app/.cache/json/index-old.json"),
  "page-2.json": require("gatsby-module-loader?name=path---page-2!/app/.cache/json/page-2.json"),
  "test.json": require("gatsby-module-loader?name=path---test!/app/.cache/json/test.json"),
  "404-html.json": require("gatsby-module-loader?name=path---404-html!/app/.cache/json/404-html.json")
}

exports.layouts = {
  "layout---index": require("gatsby-module-loader?name=component---src-layouts-index-js!/app/.cache/layouts/index.js")
}


// WEBPACK FOOTER //
// ./.cache/async-requires.js